import { Widget } from '../pages/UserGroupsPage';

export type InternalWidgetTypes =
  | 'DASHBOARDS'
  | 'TODO_LIST'
  | 'DOWNLOADS'
  | 'STORY'
  | 'SPINRAD';

export const fixedWidgets = [
  {
    name: 'Dashboards',
    url: '/dashboards',
    type: 'internal',
    internalWidgetType: 'DASHBOARDS' as InternalWidgetTypes,
  },
  {
    name: 'TODO List',
    url: '/tasks',
    type: 'internal',
    internalWidgetType: 'TODO_LIST' as InternalWidgetTypes,
  },
  {
    name: 'Downloads',
    url: '/downloads',
    type: 'internal',
    internalWidgetType: 'DOWNLOADS' as InternalWidgetTypes,
  },
  {
    name: 'Stories',
    url: '/Story',
    type: 'internal',
    internalWidgetType: 'STORY' as InternalWidgetTypes,
  },
  {
    name: 'Spinrad',
    url: '/spinrad',
    type: 'internal',
    internalWidgetType: 'SPINRAD' as InternalWidgetTypes,
  },
];

export function isDownloadWidget(widget: {
  type: string;
  url: string;
}): boolean {
  return (
    widget.type === 'internal' &&
    (widget.url.startsWith('/downloads?') || widget.url === '/downloads')
  );
}

export function isStoryWidget(widget: { type: string; url: string }): boolean {
  return (
    widget.type === 'internal' &&
    (widget.url.toLowerCase().startsWith('/story?') ||
      widget.url.toLowerCase() === '/story')
  );
}

export function isSpinradWidget(widget: {
  type: string;
  url: string;
}): boolean {
  return (
    widget.type === 'internal' &&
    (widget.url.toLowerCase().startsWith('/spinrad?') ||
      widget.url.toLowerCase() === '/spinrad')
  );
}

/**
 * Traverse the widgets tree to find all download widgets
 * @param widgets Widgets array
 * @param widgetId Optional widget id to filter
 * @return Array of download widgets
 */
export function getDownloadWidgets(
  widgets: Widget[],
  widgetId?: number,
): Widget[] {
  if (!widgets || widgets.length === 0) {
    return [];
  }
  const downloadWidgets: Widget[] = [];

  widgets.forEach(widget => {
    if (isDownloadWidget(widget)) {
      if (widgetId) {
        // if id is provided, filter
        if (widget.widgetId === widgetId) {
          downloadWidgets.push(widget);
        }
      } else {
        downloadWidgets.push(widget);
      }
    }
    if (widget.children) {
      const childWidgets = getDownloadWidgets(widget.children, widgetId);
      downloadWidgets.push(...childWidgets);
    }
  });

  return downloadWidgets;
}

/**
 * Traverse the widgets tree to find all story widgets
 * @param widgets Widgets array
 * @param widgetId Optional widget id to filter
 * @return Array of story widgets
 */
export function getStoryWidgets(
  widgets: Widget[],
  widgetId?: number,
): Widget[] {
  if (!widgets || widgets.length === 0) {
    return [];
  }
  const storieWidgets: Widget[] = [];

  widgets.forEach(widget => {
    if (isStoryWidget(widget)) {
      if (widgetId) {
        // if id is provided, filter
        if (widget.widgetId === widgetId) {
          storieWidgets.push(widget);
        }
      } else {
        storieWidgets.push(widget);
      }
    }
    if (widget.children) {
      const childWidgets = getStoryWidgets(widget.children, widgetId);
      storieWidgets.push(...childWidgets);
    }
  });

  return storieWidgets;
}

/**
 * Traverse the widgets tree to find all spinrad widgets
 * @param widgets Widgets array
 * @param widgetId Optional widget id to filter
 * @return Array of spinrad widgets
 */
export function getSpinradWidgets(
  widgets: Widget[],
  widgetId?: number,
): Widget[] {
  if (!widgets || widgets.length === 0) {
    return [];
  }
  const spinradWidgets: Widget[] = [];

  widgets.forEach(widget => {
    if (isSpinradWidget(widget)) {
      if (widgetId) {
        // if id is provided, filter
        if (widget.widgetId === widgetId) {
          spinradWidgets.push(widget);
        }
      } else {
        spinradWidgets.push(widget);
      }
    }
    if (widget.children) {
      const childWidgets = getSpinradWidgets(widget.children, widgetId);
      spinradWidgets.push(...childWidgets);
    }
  });

  return spinradWidgets;
}
